/**
 * @generated SignedSource<<c1b5582a2a4e347be6060e86d5a47476>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type IntegrationNewsfeedProvider = "BOKAKLIPP" | "FALCON";
import { FragmentRefs } from "relay-runtime";
export type IntegrationNewsfeedScreen_IntegrationNewsfeedListItem$data = {
  readonly id: string;
  readonly provider: IntegrationNewsfeedProvider;
  readonly " $fragmentType": "IntegrationNewsfeedScreen_IntegrationNewsfeedListItem";
};
export type IntegrationNewsfeedScreen_IntegrationNewsfeedListItem$key = {
  readonly " $data"?: IntegrationNewsfeedScreen_IntegrationNewsfeedListItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationNewsfeedScreen_IntegrationNewsfeedListItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IntegrationNewsfeedScreen_IntegrationNewsfeedListItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    }
  ],
  "type": "IntegrationNewsfeed",
  "abstractKey": null
};

(node as any).hash = "4f16f582eaa628eb177aa2eeacecaa0e";

export default node;
